// Leaf module: imported by the route registry (pages/corporate/routes/meetings.ts)
// and TMEditor/type.ts. Keep free of component/hook imports — utils.tsx pulls the
// PageEditor types and the route registry itself back (an import cycle).
export enum SidePanelTabs {
  Details = 'details',
  Recap = 'recap',
  Notes = 'notes',
}
